import React, { useState } from 'react';
import './ContentBody.css';
import { AnimatedSection } from '../../AnimatedSection';
import YoutubVideo from '../YoutubVideo';

const ContentBody = ({ videoTitle, videoDescription, videoUrl }) => {

    const newsItems = [
        {
            id: 1,
            videoTitle: "THE SERIES",
            videoDescription: "Game 7 dives into the most unforgettable do-or-die games ever played, revealing the drama, pressure, and triumph that make these moments unforgettable.",
            videoUrl: "https://www.youtube.com/embed/PKehFiyf9_I?autoplay=0",
            date: "15.06.2024"
        },
        {
            id: 2,
            videoTitle: "24 HOURS TO GAME 7",
            videoDescription: "Follow the journey in the final 24 hours leading up to GAME 7. From locker room prep to fan energy, experience the intensity, pressure, and passion that define the last game.",
            videoUrl: "https://www.youtube.com/embed/PKehFiyf9_I?autoplay=0",
            date: "15.06.2024"
        },
        {
            id: 3,
            videoTitle: "THE SERIES ok",
            videoDescription: "Game 7 dives into the most unforgettable do-or-die games ever played, revealing the drama, pressure, and triumph that make these moments unforgettable.",
            videoUrl: "https://www.youtube.com/embed/PKehFiyf9_I?autoplay=0",
            date: "15.06.2024"
        },
        {
            id: 5,
            videoTitle: "24 HOURS TO GAME 7dd",
            videoDescription: "Follow the journey in the final 24 hours leading up to GAME 7. From locker room prep to fan energy, experience the intensity, pressure, and passion that define the last game.",
            videoUrl: "https://www.youtube.com/embed/PKehFiyf9_I?autoplay=0",
            date: "15.06.2024"
        },
    ];
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlayClick = () => {
        setIsPlaying(true);
    };

    return (

        <section className=" ">
            <div className="text-3xl text-white text-center font-bold uppercase md:hidden">
                content
            </div>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row">
                <div className="md:w-2/5 items-center justify-center relative flex">
                    <AnimatedSection>
                        <img
                            src="/content_data/1section/iphone.png"
                            alt="Prime Video"
                            className="prime-logo iphone-rotation w-44 md:w-full"
                        />
                    </AnimatedSection>
                </div>

                <div className="md:w-3/5 items-end justify-center relative flex pt-10">
                    <div className="right-content">
                        <div className="text-content">
                            <div className="video-title-section3">
                                <span className="word1">never</span> &nbsp;
                                <span className="word2">miss</span> <br />
                                <span className="word3" style={{ marginTop: '-20px' }}>the</span>  &nbsp;
                                <span className="word4" style={{ marginTop: '-20px' }}>game</span>
                            </div>
                            <AnimatedSection>
                                <p className="content-description">
                                    From exclusive series on Prime, to YouTube highlights and brand stories, this is where GAME 7 goes beyond the scoreboard. Watch, stream, and connect with the culture that drives the game.
                                </p>
                            </AnimatedSection>
                        </div>
                    </div>
                </div>

            </div>



            {newsItems.map((news) => (
                <YoutubVideo key={news.id} videoTitle={news.videoTitle} videoDescription={news.videoDescription} videoUrl={news.videoUrl} />
            ))}
        </section>
    );
};

export default ContentBody;
